/**
 * Keep-scroll, click side. Links marked [data-wolv-keep-scroll] (product switch,
 * tier cards) store the target path and the current scroll offset; the inline
 * pre-paint script in layout/theme.liquid applies that offset on the next page
 * before the body becomes visible, so the switch reads as an in-place update.
 */
const KEY = 'wolv:keep-scroll';

function remember(event) {
  const link = event.target.closest('a[data-wolv-keep-scroll]');
  if (!link || event.defaultPrevented) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
  let path = '';
  try {
    path = new URL(link.href, window.location.href).pathname;
  } catch {
    return;
  }
  try {
    sessionStorage.setItem(KEY, `${path}|${Math.round(window.scrollY)}`);
  } catch {
    // storage unavailable: navigate normally
  }
}

document.addEventListener('click', remember, true);
